import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-user-detail-model',
  templateUrl: './user-detail-model.component.html',
  styleUrls: ['./user-detail-model.component.scss']
})
export class UserDetailModelComponent {
  @Input() user : any;
  @Output() sendData = new EventEmitter<any>();
  visible : any = true

  setState($event : any){
    this.sendData.emit();
    this.visible = true
  }
  constructor(
    
    ) { 

    console.log("Event bind=================>")
      
    }


}
